export default "__VITE_ASSET__BMVPppWI__"